export default "__VITE_ASSET__Cn6N_iKr__"